module.exports = __webpack_public_path__ + "img/zjScan.d211fb66.png";